import { graphql } from '@apollo/client/react/hoc';
import * as React from 'react';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import ModalMenuItem from 'components/ModalMenuItem';
import TextWithIcon from 'components/TextWithIcon';
import Group from 'entities/Group';
import EditBirthdateForm, { EditBirthdateFormProps } from './EditBirthdateForm';
import UPDATE_BIRTHDATE_MUTATION from 'users/components/UsersProfile/mutations/UpdateBirthdate.gql';

const withBirthdateMutation = graphql(UPDATE_BIRTHDATE_MUTATION, {
  props: ({ ownProps, mutate }) => ({
    ...ownProps,
    mutate: mutate as EditBirthdateFormProps['mutate'],
  }),
});
const BirthdateForm = withBirthdateMutation(EditBirthdateForm) as React.ComponentType<
  Omit<EditBirthdateFormProps, 'mutate'>
>;

type Props = {
  menuKey: string;
  userUuid: string;
  organization?: {
    id: number;
    uuid: string;
    name: string;
  };
  groupToAdmin?: Group;
  onUserUpdate?: (eventName?: string) => Promise<void>;
  canEditBirthdate?: boolean;
  currentBirthdate?: string;
};

function EditBirthdateModal(props: Props) {
  const { menuKey, userUuid, onUserUpdate = () => {}, canEditBirthdate, currentBirthdate } = props;

  if (!canEditBirthdate) {
    return null;
  }

  const birthdateModal = (
    <Dialog title="Edit birthdate" size="small">
      <BoxBody divided size="small">
        <BirthdateForm
          userUuid={userUuid}
          currentBirthdate={currentBirthdate}
          onBirthdateUpdated={() => onUserUpdate('user_profile.birthdate.updated')}
        />
      </BoxBody>
    </Dialog>
  );

  return (
    <ModalMenuItem menuKey={menuKey} modal={birthdateModal} disabled={!canEditBirthdate}>
      <TextWithIcon
        icon="calendar"
        color="graphite"
        iconColor="graphite"
        iconSize="medium"
        size="xsmall"
      >
        Edit birthdate
      </TextWithIcon>
    </ModalMenuItem>
  );
}

export default EditBirthdateModal;
